import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import { PaymentRecordTable } from "../../components/PaymentRecordTable";
import { useContext } from "react";
import { UserProfileContext } from "../../context/UserContext";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const PaymentRecords = () => {
  const { userProfile } = useContext(UserProfileContext) || {};
  const estateId = useSelector(
    (state) => state?.account?.activeAccount?.estateId,
  );
  const navigate = useNavigate();

  const handleRepurchase = (record) => {
    if (!record || !record.amountPaid) return;
    const amount = encodeURIComponent(record.amountPaid);
    navigate(`/buy-water?amount=${amount}`);
  };

  return (
    <Box>
      <Heading size="lg" mb="20px">
        Payment Records
      </Heading>
      <PaymentRecordTable
        userId={userProfile?._id}
        estateId={estateId}
        onRepurchase={handleRepurchase}
      />
    </Box>
  );
};

export default PaymentRecords;
